(() => {
  const initShowcase = (showcase) => {
    const desktopTabs = Array.from(showcase.querySelectorAll('[data-helmet-tab]'));
    const desktopGroups = Array.from(showcase.querySelectorAll('[data-helmet-group]'));
    const desktopPrev = showcase.querySelector('[data-helmet-desktop-prev]');
    const desktopNext = showcase.querySelector('[data-helmet-desktop-next]');
    let desktopIndex = Math.max(0, desktopGroups.findIndex((group) => group.classList.contains('is-active')));

    const activateDesktop = (nextIndex) => {
      if (desktopGroups.length === 0) return;

      desktopIndex = (nextIndex + desktopGroups.length) % desktopGroups.length;
      const activeHandle = desktopGroups[desktopIndex].dataset.helmetGroup;

      desktopTabs.forEach((tab) => {
        const active = tab.dataset.helmetTab === activeHandle;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      desktopGroups.forEach((group, index) => {
        const active = index === desktopIndex;
        group.classList.toggle('is-active', active);
        group.hidden = !active;
      });
    };

    desktopTabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateDesktop(index));
    });

    if (desktopPrev) desktopPrev.addEventListener('click', () => activateDesktop(desktopIndex - 1));
    if (desktopNext) desktopNext.addEventListener('click', () => activateDesktop(desktopIndex + 1));
    activateDesktop(desktopIndex);

    const mobileList = showcase.querySelector('.cyril-helmet-showcase__mobile-list');
    const mobileSlides = Array.from(showcase.querySelectorAll('.cyril-helmet-showcase__mobile-slide'));
    const mobileTabs = Array.from(showcase.querySelectorAll('[data-helmet-mobile-tab]'));
    const mobilePrev = showcase.querySelector('[data-helmet-mobile-prev]');
    const mobileNext = showcase.querySelector('[data-helmet-mobile-next]');
    const mobileCounter = showcase.querySelector('[data-helmet-mobile-counter]');
    const mobileFrame = showcase.querySelector('[data-helmet-mobile-frame]');
    let mobileIndex = 0;

    const updateMobile = (nextIndex) => {
      if (!mobileList || mobileSlides.length === 0) return;

      mobileIndex = Math.max(0, Math.min(nextIndex, mobileSlides.length - 1));
      mobileList.style.transform = `translate3d(-${mobileIndex * 100}%, 0, 0)`;

      const activeColor = mobileSlides[mobileIndex].dataset.helmetSlideColor;
      mobileTabs.forEach((tab) => {
        const active = tab.dataset.helmetMobileTab === activeColor;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      if (mobilePrev) mobilePrev.disabled = mobileIndex === 0;
      if (mobileNext) mobileNext.disabled = mobileIndex === mobileSlides.length - 1;
      if (mobileCounter) mobileCounter.textContent = `${mobileIndex + 1} / ${mobileSlides.length}`;
    };

    mobileTabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const slideIndex = Number(tab.dataset.helmetSlideIndex || 0);
        updateMobile(slideIndex);
      });
    });

    if (mobilePrev) mobilePrev.addEventListener('click', () => updateMobile(mobileIndex - 1));
    if (mobileNext) mobileNext.addEventListener('click', () => updateMobile(mobileIndex + 1));

    let startX = 0;
    let startY = 0;
    if (mobileFrame) {
      mobileFrame.addEventListener(
        'touchstart',
        (event) => {
          const touch = event.touches[0];
          startX = touch.clientX;
          startY = touch.clientY;
        },
        { passive: true }
      );

      mobileFrame.addEventListener(
        'touchend',
        (event) => {
          const touch = event.changedTouches[0];
          const diffX = touch.clientX - startX;
          const diffY = touch.clientY - startY;

          if (Math.abs(diffX) > 40 && Math.abs(diffX) > Math.abs(diffY)) {
            updateMobile(mobileIndex + (diffX < 0 ? 1 : -1));
          }
        },
        { passive: true }
      );
    }

    updateMobile(0);
  };

  document.querySelectorAll('[data-cyril-helmet-showcase]').forEach(initShowcase);
})();
